<template>
  <b-modal v-model="showNotif" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
    <div class="d-flex justify-content-start align-items-start error-wrapper">
      <div class="mb-4">
        <span class="fa-stack fa-2x fontPrimary">
          <i class="fa-duotone fa-circle-info fa-stack-2x"></i>
          <i class="fa-duotone fa-check fa-stack-1x"></i>
        </span>
      </div>
      <div class="desc">{{description}}</div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    showNotif: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: 'تعداد فیلان تا کاربر رو زدیم تو گوششون',
    },
  },
  watch:{
    showNotif(val){
      if(val === false) {
        this.$emit('isClose',val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.fa-stack-1x {
  left: 23px;
}
.fontPrimary {
  color: var(--bs-blue);
}
.desc {
  font-size: 13pt;
  margin: 0 5px 0 0;
}
</style>